var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-data-box"},[(_vm.loading)?_c('Loading',{attrs:{"loading":_vm.loading}}):_vm._e(),(!_vm.loading)?_c('span',{staticClass:"no-data-txt"},[_vm._v(" "+_vm._s(_vm.emptyTxt)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }